import { render, staticRenderFns } from "./AutopilotSpecs.vue?vue&type=template&id=94976fe0&scoped=true&"
import script from "./AutopilotSpecs.vue?vue&type=script&lang=js&"
export * from "./AutopilotSpecs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94976fe0",
  null
  
)

export default component.exports